import React, { useState } from "react";
import { IconSizes } from "@mlb/react-patterns/components/Icon/icon.types";
import Popover from "@mlb/react-patterns/components/Popover/popover";
import {
  PopoverPlacement,
  ShowOnEvent,
} from "@mlb/react-patterns/components/Popover/popover.types";
import {
  SettingsButton,
  SettingsMenuPopoverWrapper,
} from "../fieldvision.style";
import Icon from "@mlb/react-patterns/components/Icon/icon";
import SettingsMenu from "./SettingsMenu";
import { Context } from "../../../context";
import { UserOptionPreset } from "../../../util/user-options";

interface SettingsMenuProps {
  speed: number;
  visualQualityPreset: UserOptionPreset;
  isSettingsMenuOpen: boolean;
  setPlaybackSpeed(speed: number): void;
  setVisualQualityPreset(quality: UserOptionPreset): void;
  setIsSettingsMenuOpen(isOpen: boolean): void;
}

const SettingsMenuPopover = (props: SettingsMenuProps) => {
  const {
    speed,
    visualQualityPreset,
    setPlaybackSpeed,
    setVisualQualityPreset,
    setIsSettingsMenuOpen,
    isSettingsMenuOpen,
  } = props;

  const popoverContent = (
    <SettingsMenu
      speed={speed}
      visualQualityPreset={visualQualityPreset}
      setPlaybackSpeed={setPlaybackSpeed}
      setVisualQualityPreset={setVisualQualityPreset}
      setIsSettingsMenuOpen={setIsSettingsMenuOpen}
    />
  );

  return (
    <SettingsMenuPopoverWrapper className="button-wrapper">
      <Popover
        theme={{}}
        placement={PopoverPlacement.TOP_END}
        popoverContent={popoverContent}
        popoverOffset={[39, 20]}
        showOnEvent={ShowOnEvent.CLICK}
        flipPopover={true}
        isOpen={isSettingsMenuOpen}
        closeOnPopperClick={false}
      >
        <SettingsButton
          title="settings"
          onClick={() => {
            isSettingsMenuOpen
              ? setIsSettingsMenuOpen(false)
              : setIsSettingsMenuOpen(true);
          }}
        >
          <Icon name="settings" size={IconSizes.MD} fill="#fff" />
        </SettingsButton>
      </Popover>
    </SettingsMenuPopoverWrapper>
  );
};

export default SettingsMenuPopover;
